document.addEventListener('DOMContentLoaded', () => {
    // Header Menu
    const body = document.querySelector('body');
    const menuButton = document.querySelector('.js-mobile-menu');
    const menuOuter = document.querySelector('.js-menu-open');
    const menuClose = document.querySelector('.js-close-mobile-menu');
    const menuParentsDesktop = jQuery('.nav li.menu-item-has-children > a').append('<svg width="10" height="5" viewBox="0 0 10 5" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M5.00427 3.27286e-05H9.06278L5.00427 4.05854L0.945768 3.27286e-05H5.00427Z" fill="currentColor"/></svg>');
    const menuParents = document.querySelectorAll('.mobile-menu .menu-item-has-children > a');


    // Open menu
    if (menuButton && menuOuter) {
        menuButton.addEventListener('click', (e) => {
            e.preventDefault();
            menuOuter.classList.add('is-open');
            body.classList.add('menu-open');
        })
    }

    // Close menu
    if (menuClose && menuOuter) {
        menuClose.addEventListener('click', (e) => {
            e.preventDefault();
            menuOuter.classList.remove('is-open');
            body.classList.remove('menu-open');
        })
    }

    // Make menus have dropdowns
    if (menuParents) {
        menuParents.forEach(element => {
            element.nextElementSibling.classList.add('hidden');
            element.addEventListener('click', (e) => {
                e.preventDefault();
                const menuToOpen = element.nextElementSibling;
                const parentClass = element.parentElement;
                if (menuToOpen.classList.contains('hidden')) {
                    menuToOpen.classList.remove('hidden');
                    parentClass.classList.add('is-open');
                } else {
                    parentClass.classList.remove('is-open');
                    menuToOpen.classList.add('hidden');
                }
            })
        });
    }

    // Add class to header on scroll
    const stickyHeader = () => {
        const body = document.querySelector('body');
        const header = document.querySelector('.header');

        if (header) {
            if (window.scrollY >= header.offsetHeight) {
                body.classList.add('is-scrolled');
                header.classList.add('is-fixed');
            } else {
                body.classList.remove('is-scrolled');
                header.classList.remove('is-fixed');
            }
        }
    }

    window.addEventListener('scroll', stickyHeader);

    // Default pos
    stickyHeader();

    // Wrap all tables in a wrapper class
    jQuery('table').wrap("<div class='table-wrapper'></div>");

    // Mobile Menu
    jQuery('.mobile-menu .menu-item-has-children > a').append('<svg class="down" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path fill="currentColor" d="M480 696 280 497h400L480 696Z"/></svg>');
    jQuery('.mobile-menu .menu-item-has-children > a').append('<svg class="right" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path fill="currentColor" d="M400 776V376l200 200-200 200Z"/></svg>');
});